import Alpine from 'alpinejs';
import focus from '@alpinejs/focus';
import intersect from '@alpinejs/intersect';
import persist from '@alpinejs/persist';
import mask from '@alpinejs/mask';
import sort from "@alpinejs/sort";

import canvasTopNavUser from '../views/components/canvas-editor/top-nav/top-nav.js';
import canvasFloatMenu from '../views/components/canvas-editor/float-menu/float-menu.js';
import {formatMoney} from "./canvas/helpers";



window.Alpine = Alpine;

Alpine.data('canvasTopNavUser', canvasTopNavUser);
Alpine.data('canvasFloatMenu', canvasFloatMenu);

Alpine.magic('formatMoney', () => formatMoney);

Alpine.plugin(focus);
Alpine.plugin(intersect);
Alpine.plugin(persist);
Alpine.plugin(mask);
Alpine.plugin(sort);


Alpine.start();
